var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"wrap":""}},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('PointShop')],1),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('PointVoucher')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }